import { AgentUserStatusDto } from './agent-api.model';

/** What the user may do in the assistant; reading existing conversations is allowed in every state. */
export type AgentAssistantState = 'notEnabled' | 'noTokens' | 'ready';

/** States in which new conversations and messages are blocked. */
export type AgentBlockedState = Exclude<AgentAssistantState, 'ready'>;

export const getAgentAssistantState = (status: AgentUserStatusDto): AgentAssistantState => {
  if (!status.isEnabled) return 'notEnabled';
  if (status.remainingTokens <= 0) return 'noTokens';
  return 'ready';
};

/** Texts of a blocked state: the full-panel view, the inline notice and the e-mail link to the office. */
export interface AgentAccessTexts {
  title: string;
  description: string;
  mailSubject: string;
}

/** Texts of the blocked states (redesign v2); the office contact comes from the environment (`AI_AGENT_ACCESS_CONTACT_EMAIL`). */
export const AGENT_ACCESS_TEXTS: Record<AgentBlockedState, AgentAccessTexts> = {
  notEnabled: {
    title: $localize`:@@AI_AGENT_NOT_ENABLED_TITLE:The assistant isn't enabled for your account`,
    description: $localize`:@@AI_AGENT_NOT_ENABLED_TEXT:The AI Assistant is turned on per user by Simlab. Once it's enabled, it will answer questions about your spaces, files, assets, tasks and events, and prepare new items for you to save.`,
    mailSubject: $localize`:@@AI_AGENT_MAIL_SUBJECT_ACCESS:SIM-ON AI assistant: access request`
  },
  noTokens: {
    title: $localize`:@@AI_AGENT_OUT_OF_TOKENS_TITLE:You've used all your tokens`,
    description: $localize`:@@AI_AGENT_OUT_OF_TOKENS_TEXT:You can still read past conversations and open their cards.`,
    mailSubject: $localize`:@@AI_AGENT_MAIL_SUBJECT_TOKENS:SIM-ON AI assistant: more tokens`
  }
};

/** `mailto:` link to the office, with the subject of the blocked state. */
export const agentAccessMailto = (email: string, texts: AgentAccessTexts): string =>
  `mailto:${email}?subject=${encodeURIComponent(texts.mailSubject)}`;
